<template>
  <div class="text" :style="textElStyles" v-html="text.text"></div>
</template>

<script>
export default {
  name: "CardUIText",
  props: {
    text: {
      type: Object,
      default() {},
    },
  },
  computed: {
    textElStyles() {
      const { textColor } = this.text;

      // direct styles
      const styles = {
        color: textColor.value,
      };
      return styles;
    },
  },
};
</script>

<style lang="scss" scoped>
.text {
  width: 100%;
  font-style: normal;
  hyphens: auto;
  overflow-wrap: anywhere;

  @include font-family("body");
  @include scale-fonts("body");
  @include setup-richtext();
}
</style>
